
import { DeviceConfigLogEntry } from '@/api/dtos/LogEntry.schema'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DeviceConfigLogEntryContent extends Vue {
  @Prop()
  logEntry!: DeviceConfigLogEntry
}
